var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#E0E5F2",
    stroke: "#E0E5F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8225 11.1835C18.5859 10.9469 18.2036 10.9469 17.967 11.1835L15 14.1445L12.033 11.1775C11.7964 10.9408 11.4141 10.9408 11.1775 11.1775C10.9408 11.4141 10.9408 11.7964 11.1775 12.033L14.1445 15L11.1775 17.967C10.9408 18.2036 10.9408 18.5859 11.1775 18.8225C11.4141 19.0592 11.7964 19.0592 12.033 18.8225L15 15.8555L17.967 18.8225C18.2036 19.0592 18.5859 19.0592 18.8225 18.8225C19.0592 18.5859 19.0592 18.2036 18.8225 17.967L15.8555 15L18.8225 12.033C19.0531 11.8024 19.0531 11.4141 18.8225 11.1835Z",
    fill: "#838AA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ec492d273f4415d958da91434504b70b.svg";
export { ForwardRef as ReactComponent };